import { motion } from "framer-motion"; // Import Framer Motion for animations
import { learningPathTwo } from "../../data/learningPath.js";

export default function LearningPath() {
  // Define animation variants for fade-in and staggered effects
  const fadeInUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Stagger child animations
      },
    },
  };

  return (
    <motion.section
      className="py-4 sm:py-12 bg-gradient-to-b "
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={staggerContainer}
    >
      <div className="container mx-auto px-6">
        {/* Title Section */}
        <motion.div className="text-center" variants={fadeInUp}>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800">
            Together Towards Your Medical{" "}
            <span className="text-orange-500">Career</span>
          </h2>
          <p className="mt-4 text-md text-gray-600">
            Tailored assistance from NEET Counselling to your Admission,
            leading you on the path to your medical career.
          </p>
        </motion.div>

        {/* Cards Section */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 mt-16"
          variants={staggerContainer}
        >
          {learningPathTwo.map((elm, i) => (
            <motion.div
              key={elm.id}
              className="flex flex-col items-center text-center"
              variants={fadeInUp}
              whileHover={{ scale: 1.05 }}
            >
              {/* Icon */}
              <div
                className="w-28 h-28 flex  items-center justify-center rounded-full"
                style={{ backgroundColor: elm.bgColor }}
              >
                <img
                  src={elm.icon}
                  alt={`icon for ${elm.title}`}
                  className="w-12 h-12"
                />
              </div>

              {/* Title & Description */}
              <div className="mt-6">
                <h3 className="text-xl font-semibold text-gray-800">
                  {elm.title}
                </h3>
                <p className="mt-2 text-sm text-gray-600">{elm.text}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
}
